import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '@technokratos-admin/app.component';
import { appConfig } from '@technokratos-admin/app.config';

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
